import AppCalendar from "components/AppCalendar";
import { UseAppFormProps } from "hooks/useAppForm";
import React, { useEffect, useState } from "react";
import { FormValueProps } from ".";
import { DATE_FORMAT } from "utils";
import moment, { Moment } from "moment";
import { apiBookingConfigIndex, BookingConfigItemProps } from "apis/booking";
import useAppSelector from "hooks/useAppSelector";
import { apiTimeFrameOptions } from "apis";

interface Props {
    form: UseAppFormProps<FormValueProps>
}

export const PageSelectDate: React.FC<Props> = ({ form }) => {
    const timeFrame = useAppSelector(state => state.timeFrame);

    const [currentMonth, setCurrentMonth] = useState<Moment>(moment());
    const [bookingConfigs, setBookingConfigs] = useState<BookingConfigItemProps[]>([]);

    useEffect(() => {
        apiTimeFrameOptions({});
    }, [])

    useEffect(() => {
        const fromDate = currentMonth.clone().startOf("month").format(DATE_FORMAT); // ngày đầu tháng
        const toDate = currentMonth.clone().endOf("month").format(DATE_FORMAT);    // ngày cuối tháng

        apiBookingConfigIndex({
            fromDate,
            toDate,
            timeFrameIds: timeFrame.list.options.map(item => item.id)
        })
            .then(res => {
                setBookingConfigs(res.data || []);
            })
    }, [currentMonth, timeFrame.list.options]);

    return (
        <div className="p-4 bg-white rounded shadow mb-2">
            <h2 className="text-lg font-bold mb-4">CHỌN NGÀY</h2>
            <AppCalendar
                shadow={false}
                onMonthChange={(m) => setCurrentMonth(m)}
                selected={form.values.date && moment(form.values.date, DATE_FORMAT)}
                onSelect={(d) => form.handleChange({ date: d.format(DATE_FORMAT) === form.values.date ? undefined : d.format(DATE_FORMAT) })}
                weekMode={Boolean(form.values.date)}
                disabledDate={(date) => {
                    if (date.isBefore(moment(), "day")) {
                        return true;
                    }
                    if (bookingConfigs.findIndex(b => b.dateSelected === date.format(DATE_FORMAT)) >= 0) {
                        return false;
                    }
                    return true;
                }}
                colorDate={(date) => {
                    if (date.day() === 0) return "error"; // Chủ nhật
                    if (date.isSame(moment(), "day")) return "active"; // Hôm nay
                    return "default";
                }}
            />
        </div>
    );
};
